import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { reduxForm, SubmissionError } from 'redux-form';

import { AppForm, appFormMapDispatchToProps, appFormMapStateToProps, AppFormOwnProps } from './appForm';

export class AppPartialSubmitForm extends AppForm {
  protected submitFunction(data: FormData, dispatch: Dispatch, props: AppFormOwnProps<FormData>) {
    if (!props.dirty) {
      throw new SubmissionError({
        _error: 'At least one field is required to change in order to submit the form.',
      });
    }
    // submit only dirty fields
    // eslint-disable-next-line no-restricted-syntax
    for (const field in props.initialValues) {
      if (props.initialValues.hasOwnProperty(field) && props.initialValues[field] === data[field]) {
        // eslint-disable-next-line no-param-reassign
        delete data[field];
      }
    }
    super.submitFunction(data, dispatch, props);
  }
}

export default connect(
  appFormMapStateToProps,
  appFormMapDispatchToProps,
)(reduxForm<any, any>({})(AppPartialSubmitForm));
